import React, { useState, useEffect } from 'react';
import { createFilterOptions } from './utils';
import FilterForm from './Form';
import { IFilterOptions } from './types';
import { StyledTopBar } from './styled';

const FilterPanel = ({ data }) => {
  const [filterOptions, setFilterOptions] = useState<IFilterOptions>({
    cdnOptions: [],
    asnOptions: [],
    policyOptions: [],
    triggerKpiOptions: [],
  });

  useEffect(() => {
    const options = createFilterOptions(data);
    setFilterOptions(options);
  }, [data]);

  return (
    <StyledTopBar>
      <FilterForm filterOptions={filterOptions} />
    </StyledTopBar>
  );
};

export default FilterPanel;
